import React from 'react';
import { Grid, Link, Typography } from '@material-ui/core';

import { VideoAsset } from '../../utils/types';

export const VideoAssetsList: React.FC<VideoAssetsListProps> = (props) => {
	const { videoAssets } = props;

	return (
		<Grid container item>
			<Grid item xs={3}>
				<Typography variant='subtitle2'>Video assets</Typography>
			</Grid>
			<Grid item xs={9}>
				{videoAssets?.length &&
					videoAssets.map((videoAsset, idx) => (
						<span key={`asset-${idx}`}>
							<Link href={videoAsset.url} variant='body2' color='secondary'>
								{videoAsset.format}
							</Link>
							<br />
						</span>
					))}
			</Grid>
		</Grid>
	);
};

type VideoAssetsListProps = { videoAssets?: VideoAsset[] };

export default VideoAssetsList;
